import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetVendorQuotationDetailQuery } from "store/services/vendorQuotationApi";

import VendorQuotationBasicDetail from "./vendorQuotationComponents/VendorQuotationBasicDetail";
import { useVendorQuotationDetailContext, VendorQuotationDetailContext } from "contexts/VendorQuotationContext";

const VendorQuotationDetailScreen = () => {
    const { id } = useParams();

    const breadcrumbs = [
        { title: "Vendor Quotations", path: "/app/crm/vendor-quotation/list" },
        { title: "Vendor Quotation Detail" },
    ];

    const {
        data: vendorQuotationDetail,
        isLoading: loadingVendorQuotation,
        error,
    } = useGetVendorQuotationDetailQuery(id);

    return (
        <VendorQuotationDetailContext.Provider
            value={{ vendorQuotationDetail, loadingVendorQuotation }}
        >
            <BreadcrumbLayout
                breadcrumbs={breadcrumbs}
                isBusy={loadingVendorQuotation}
                headerActions={<PageActions />}
            >
                <BreadcrumbLayout.Error error={error} />
                <BreadcrumbLayout.Paper>
                    <VendorQuotationBasicDetail />
                    <Divider />
                </BreadcrumbLayout.Paper>
            </BreadcrumbLayout>
        </VendorQuotationDetailContext.Provider>
    );
};

export default VendorQuotationDetailScreen;

const PageActions = () => {
    const { vendorQuotationDetail } = useVendorQuotationDetailContext();
    return (
        <div className="flex items-center gap-4">
            <Link to={`/app/crm/vendor-quotation/${vendorQuotationDetail?._id}/edit`}>
                <Button startIcon={<EditOutlined />} variant="contained">
                    Edit
                </Button>
            </Link>
        </div>
    );
};